import { forwardRef } from 'react';
import { Drawer, HandleProps } from 'vaul';
import { clsx } from '@team/clsx';
import css from './style.module.css';

export const Entry = forwardRef<HTMLDivElement, HandleProps>(
  function Component(props, forwardedRef) {
    return (
      <Drawer.Handle
        {...props}
        className={clsx(props.className, css.root)}
        ref={forwardedRef}
      />
    );
  }
);
